import { ICPlatformVersion } from '@retailer-platform/dashboard/access-control'
import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'
import { FeatureToggle } from './featureToggles'

/** Shared with useFeaturedCollectionSetsAccess — keep route + UI gates aligned. */
export const featuredCollectionSetsAccessControl: DomainAccessControlConfig = [
  {
    featureToggles: [FeatureToggle.featuredCollectionSets],
  },
  {
    minICPlatformVersion: ICPlatformVersion.r2026_08_0,
  },
]

export const featuredCollectionSetsAdminAccessControl: DomainAccessControlConfig = [
  {
    permissions: [Permission.Admin],
    featureToggles: [FeatureToggle.featuredCollectionSets],
  },
  {
    permissions: [Permission.Admin],
    minICPlatformVersion: ICPlatformVersion.r2026_08_0,
  },
]
